import parse from 'html-react-parser';

export default function RichText(props) {
    return (
        <div className="relative mx-auto max-w-7xl py-1 px-6 lg:px-8" >
            <div className='text-lg'>
                {parse(props.content ?? '')}
            </div>
        </div>
    )
}
